import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import Qs from 'qs'
import store from './store'
import tpheader from './pages/tpheader/TpHeader.vue'
import tpfooter from './pages/tpfooter/TpFooter.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


let cssName = ''
if(window.location.href.split('/#')[0] === 'https://wyjs.ca163.net'){
// if(window.location.href.split('/#')[0] === 'http://test-wyjs.ca163.com'){
    import ('./theme/jx/index.css')
}else{
    import ('./theme/ljjs/index.css')
}


Vue.use(ElementUI);

Vue.config.productionTip = false

Vue.prototype.loginRemind = false;

Vue.component('tpheader', tpheader);
Vue.component('tpfooter', tpfooter);

//本地测试
Vue.prototype.testUrl = "https://jspx.ca163.net"
// Vue.prototype.testUrl = "https://jsyx-test.ca163.net"
//
// Vue.prototype.baseUrl = 'https://jsyx-test.ca163.net/';
// Vue.prototype.imgUrl = 'https://jsyx-test.ca163.net/img/';
// Vue.prototype.wordUrl = 'https://jsyx-test.ca163.net/work/';
// Vue.prototype.musicUrl = 'https://jsyx-test.ca163.net/music/';
// Vue.prototype.classUrl = 'https://jsyx-test.ca163.net/class/';
// Vue.prototype.bannerUrl = 'https://jsyx-test.ca163.net/banner/';
// Vue.prototype.exportUrl = 'https://jsyx-test.ca163.net/export_excel/';

//千万不要用正式
Vue.prototype.baseUrl='https://jspx.ca163.net/';
Vue.prototype.imgUrl='https://jspx.ca163.net/img/';
Vue.prototype.bannerUrl='https://jspx.ca163.net/banner/';
Vue.prototype.wordUrl='https://jspx.ca163.net/work/';
Vue.prototype.musicUrl='https://jspx.ca163.net/music/';
Vue.prototype.exportUrl = 'https://jspx.ca163.net/export_excel/';
Vue.prototype.classUrl = 'https://jspx.ca163.net/class/';

//根据域名获取店铺id
Vue.prototype.$getStoreId = function () {
    let data = {
        url: window.location.href.split('/#')[0]
        // url: "http://jspx.ca163.net"
        // url: "https://education-project.bayou-tech.cn"
        // url: "https://jsyx-test.ca163.net"
        // url: "http://test-wyjs.ca163.com"
    };
    return this.$post("shops/get_url", data).then(res => {
        return res.data.result.id;
    });
}

//get请求
Vue.prototype.$get = function (api, data) {
    if (data === undefined) {
        data = {};
    }
    var ox = axios.get(this.baseUrl + api, { params: data });
    return ox;
}

//post请求
Vue.prototype.$post = function (api, data) {
    // data.t = new Date().getTime();
    data = Qs.stringify(data);
    var ox = axios.post(this.baseUrl + api, data);
    return ox;
}

//上传跨域问题
Vue.prototype.$upload = function (url, q) {
    let Fromdata = new FormData()
    Fromdata.append('file', q.file)


    let config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    // // console.log(Fromdata);
    // // console.log(url);
    let upload = axios.post(url, Fromdata, config)
    return upload
}

Vue.prototype.$Qs = function (data) {
    data = Qs.stringify(data);
    let ox = data
    return ox;
}
Vue.prototype.$http = axios
// Vue.prototype.$http = function (api, data, headers) {
//     data = Qs.stringify(data);
//     var ox = axios.post(this.baseUrl + api, data,headers);
//     return ox;
// }


//判断数据是否异常
Vue.prototype.$isAbnormal = function (val) {
    return val == '' || String(val) == 'undefined' || String(val) == 'null';
}

//判断跳转学习页面
Vue.prototype.$toClass = function (id, is_project, purchased_id) {
    //多端判断
    if (this.$store.state.id) {
        //如果登录则再判断是否已经购买该课程
        this.$post('users/isPay', { product_id: id, token: this.$store.state.id }).then(res => {
            // // console.log(res.data.result);
            let path = '';
            let purchased_id = '';
            // 返回true则没有购买，返回一个数组就说明已经购买
            // 若已经购买课程则跳转学习页面，若没有则跳转详情页面
            if (res.data.result == true && is_project == 0) {
                path = '/classdetails'
            } else if (res.data.result == true && is_project == 1) {
                path = '/detailsPage';
            } else if (res.data.result != true && is_project == 0) {
                path = '/classstudy';
                purchased_id = res.data.result[0].purchased_id
            } else {
                path = '/lessonstudy';
            }
            let address = this.$router.resolve({
                path: path,
                query: {
                    id: id,
                    purchased_id: purchased_id
                }
            });
            window.open(address.href, "_blank")
        })
    } else {
        //如果没有登录则跳转课程详情
        let noLoginPath = '';
        is_project == 0 ? noLoginPath = '/classdetails' : noLoginPath = '/detailsPage';
        let address = this.$router.resolve({
            path: noLoginPath,
            query: {
                id: id
            }
        });
        window.open(address.href, "_blank");

    }
}



new Vue({
    router,
    store,
    // data(){
    //   return {
    //     isGetData:false,
    //   }
    // },
    render: h => h(App)
}).$mount('#app')
